import React from 'react';
import { criteriaStore } from 'stores/CriteriaStore';

export function HeaderRow(props) {
  const { label } = props;
  return (
    <tr className='summary-header-row'>
      <td colSpan={2}>{label}</td>
    </tr>
  );
}

export function ItemRow(props) {
  const standardsVersion = criteriaStore.getState().standardsVersion;
  const { details } = props;
  const { label, value, jsxLabel, jsxValue, note } = details;

  let renderedLabel = jsxLabel ? jsxLabel : label;
  let renderedValue = jsxValue ? jsxValue : value;

  renderedValue =
    renderedLabel === 'NO SEISMIC SPECTRUM' ? (
      <span>
        Design and MCE<sub>R</sub> spectrum data not available for this location
      </span>
    ) : (
      renderedValue
    );

  if (standardsVersion === '7-22' && note && note.includes('Special Wind Region')) {
    const splitText = note.split(' -- ');
    const pre = splitText[0];
    const post = splitText[1];
    renderedValue = (
      <span>
        <span style={{ color: 'red', fontWeight: 'bold' }}>{pre}</span> -- {post}
      </span>
    );
  }

  return (
    <tr className='summary-item-row'>
      <td>{renderedLabel}</td>
      <td>{renderedValue}</td>
    </tr>
  );
}

export function SiteInfoRow(props) {
  const { label, value } = props;
  return (
    <tr className='summary-item-row'>
      <td>{label}:</td>
      {label === 'Address' ? (
        <td>
          <address>{value}</address>
        </td>
      ) : (
        <td>{value}</td>
      )}
    </tr>
  );
}
